export const BORDER_SPACING = '1.7rem'
export const BORDER_RADIUS = '1.5rem'
